// extracted by mini-css-extract-plugin
module.exports = {"saveIcon":"LikeButton-module__saveIcon___1mZuA","root":"LikeButton-module__root___2fucz","saveIconSaved":"LikeButton-module__saveIconSaved___2hvmt"};